if (!customElements.get('expandable-cards')) {
  customElements.define(
    'expandable-cards',
    class ExpandableCards extends HTMLElement {
      constructor() {
        super();
        this.cards = Array.from(this.querySelectorAll('.js-expandable-card'));
        this.onCardClick = this.onCardClick.bind(this);
      }

      connectedCallback() {
        if (!this.cards.length) return;

        this.cards.forEach((card) => {
          card.addEventListener('click', this.onCardClick);
        });
      }

      onCardClick(e) {
        const current = e.currentTarget;
        this.cards.forEach((card) => {
          card.classList.remove('active');
        });
        current.classList.add('active');
      }

      disconnectedCallback() {
        if (!this.cards.length) return;
        this.cards.forEach((card) => {
          card.removeEventListener('click', this.onCardClick);
        });
      }
    }
  );
}
